import React, { useState } from 'react'
import WorldMap from './WorldMap'
import { GameState } from '../types'

import { Language } from '../data/translations'

const VictoryPointAssignModal: React.FC<{
  onAssign: (zoneId: number) => void
  gameState?: GameState
  language: Language
}> = ({ onAssign, gameState, language }) => {
  const [confirmZoneId, setConfirmZoneId] = useState<number | null>(null)

  return (
    <div className="fixed inset-0 z-50 bg-black">
      <WorldMap
        onBack={() => { }} // No back button in this mode
        gameState={gameState}
        isCaptureMode={true}
        onCapture={(zoneId) => setConfirmZoneId(zoneId)}
        language={language}
      />

      {confirmZoneId !== null && (
        <div className="absolute inset-0 flex items-center justify-center z-50 bg-black/60 backdrop-blur-sm">
          <div className="bg-slate-900 border-2 border-amber-500 rounded-xl p-8 max-w-md w-full shadow-[0_0_50px_rgba(245,158,11,0.3)] animate-[fadeIn_0.2s_ease-out]">
            <h2 className="text-2xl font-bold text-white mb-2 text-center">Capture Zone {confirmZoneId}?</h2>
            <p className="text-slate-400 text-center mb-8">
              Assigning a victory point to this zone will increase your faction's influence here.
            </p>

            <div className="flex gap-4">
              <button
                onClick={() => setConfirmZoneId(null)}
                className="flex-1 py-3 rounded-lg font-bold text-slate-300 bg-slate-800 hover:bg-slate-700 transition-colors border border-slate-700"
              >
                Cancel
              </button>
              <button
                onClick={() => onAssign(confirmZoneId)}
                className="flex-1 py-3 rounded-lg font-bold text-black bg-amber-500 hover:bg-amber-400 transition-colors shadow-lg shadow-amber-500/20"
              >
                Confirm Capture
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default VictoryPointAssignModal